/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getUsageAudioV2ResultSchema = z.object({
  audioUrl: z.string(),
  wordTimings: z.array(wordTimingSchema).optional(),
});

export type IGetUsageAudioV2Result = z.infer<typeof getUsageAudioV2ResultSchema>;

export const getUsageAudioV2ResponseSchema = createApiResponseSchema(
  getUsageAudioV2ResultSchema,
) as z.ZodSchema<IAPI<IGetUsageAudioV2Result>>;

export type IGetUsageAudioV2Response = IAPI<IGetUsageAudioV2Result>;
